import moment from "moment/min/moment-with-locales";
import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useFetchData } from "../components/HelperHooks";
import PageDesciption from "../components/PageDesciption";
import DatePicker, { today } from "../components/Pickers/DatePicker";
import HoursPicker from "../components/Pickers/HoursPicker";
import StationPicker from "../components/Pickers/StationPicker";
import { useUserFormState } from "../components/UserSelection";
import { DataContent, InputSelection, ModulePage } from "../components/pageSections";
import ScheduleCheckHourTable from "../components/scheduleCheck/ScheduleCheckHourTable";
import ScheduleCheckSongsTable from "../components/scheduleCheck/ScheduleCheckSongsTable";

export default function ScheduleCheck() {
    const moduleName = "scheduleCheck";

    const [formData, setFormData, saveFormData, loadFormData] = useUserFormState(moduleName);
    const [loading, errorCode, data, fetchData] = useFetchData();

    const [submittedFormData, setSubmittedFormData] = useState(null);

    const predefinedRanges = [today()];

    async function handleFormSubmit(event) {
        event.preventDefault();
        await saveFormData();
        await saveFormData(formData.station[0].radio_id);
        const date = moment(formData.date).format("YYYY-MM-DD");
        const url = `/schedule_check/?radio_id=${formData.station[0].radio_id}&date=${date}&start_hour=${formData.hourRange[0]}&end_hour=${formData.hourRange[1]}`;
        await fetchData(url);
        setSubmittedFormData({ ...formData });
    }

    return (
        <ModulePage>
            <ModulePage.Title>Schedule Check</ModulePage.Title>
            <ModulePage.InputSelection handleFormSubmit={handleFormSubmit} disabled={!formData.station.length || !formData.date}>
                <InputSelection.Main>
                    <StationPicker
                        formData={formData}
                        setFormData={setFormData}
                        name={moduleName}
                        moduleFilterFunction={x => x.module_id === 36}
                        loadOnChange={loadFormData}
                    />
                    <DatePicker formData={formData} setFormData={setFormData} predefinedRanges={predefinedRanges} />
                    <HoursPicker formData={formData} setFormData={setFormData} name={moduleName} />
                </InputSelection.Main>
            </ModulePage.InputSelection>
            <ModulePage.DataContent loading={loading} errorCode={errorCode} multiPanel>
                <DataContent.Placeholder show={!data}>
                    <PageDesciption
                        className="bg-white p-4 px-4"
                        title={"Schedule Check"}
                        whatList={[
                            "Did the djs play everything they were supposed to?",
                            "Find songs that were skipped, songs that were added, and songs that were played, but not in the order they were supposed to be played",
                        ]}
                        knowList={[
                            {
                                text: "An output from your scheduling software is required to compare the “planned” list to the actual airplay. ",
                            },
                            { text: "Reach out to your radioanalyzer support if you are interested in setting up Schedule Check" },
                        ]}
                        videoSrc="https://www.youtube.com/embed/qtp8v-88o74?si=23VxDtGicM5TuTqh"
                    />
                </DataContent.Placeholder>
                {data && (
                    <Container fluid>
                        <ScheduleCheckHourTable data={data.hours} submittedFormData={submittedFormData} />
                        <hr className="m-2" />
                        <ScheduleCheckSongsTable data={data.songs} submittedFormData={submittedFormData} />
                    </Container>
                )}
            </ModulePage.DataContent>
        </ModulePage>
    );
}
